import Store from '@/store'

export default [
  {
    path: '/industrias',
    name: 'industrias-index',
    beforeEnter: async (to, from, next) => {
      await Store.dispatch('getPaginateIndustrias')
      next()
    },
    meta: {
      title: 'Industrias',
      paginateMethod: 'getPaginateIndustrias',
      paginateAttr: 'paginateIndustrias',
      twoLines: true,
      titleAttr: item => item['nome_fantasia'],
      subtitleAttr: item => item['razao_social'],
      routeToCreate: 'industrias-create',
      routeToEdit: 'industrias-update',
      emptyList: 'Nenhuma indústria foi cadastrada.',
      avatarIcon: 'apartment',
      pageAttr: 'industriaPage',
      pageCommit: 'setIndustriaPage',
      filterAttr: 'industriaFilter',
      filterCommit: 'setIndustriaFilter',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/paginate')
    }
  },
  {
    path: '/industrias/novo',
    name: 'industrias-create',
    beforeEnter: async (to, from, next) => {
      await Store.dispatch('getCidades')
      await Store.commit('setIndustria', {})
      next()
    },
    meta: {
      title: 'Nova industria',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/industria/id')
    }
  },
  {
    path: '/industrias/:id',
    name: 'industrias-update',
    props: true,
    beforeEnter: async (to, from, next) => {
      await Store.dispatch('getCidades')
      await Store.dispatch('getIndustria', {
        id: Number(to.params.id)
      })
      next()
    },
    meta: {
      title: 'Atualizar industria',
      routeToEditTelefone: 'industrias-update-telefone',
      routeToAddTelefone: 'industrias-create-telefone',
      documentAttrTelefone: 'industria',
      routeToEditEmail: 'industrias-update-email',
      routeToAddEmail: 'industrias-create-email',
      documentAttrEmail: 'industria',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/industria/id')
    }
  }
]
